import { ProcessosTab } from '@/features/processos';

export default function Processos() {
  return <ProcessosTab />;
}
